<script>
  // footer with information about program below each page.
  // situated below the main container
</script>

<footer class="not-print">
  <div class="bottom">
    <p align="center">
      Horoscoopberekening: (beta)versie 2.0.5 build: 20240212
    </p>
  </div>
</footer>

<style>
  .bottom {
    font-size: x-small;
  }
  .bottom p {
    margin: 0;
  }

  @media print {
    .not-print {
      display: none;
    }
  }
</style>
